import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/source_www_file/www-sanfu-html/app/layouts/default.vue").then(m => m.default || m))
}